const pharmaciesRoutes = {
  getAllPharmacies: "/marketplace/pharmacies",
  createPharmacy: "/marketplace/pharmacies/create",
  updatePharmacy: "/marketplace/pharmacies/update",
  deletePharmacy: "/marketplace/pharmacies/delete",
  uploadImage: "/marketplace/pharmacies/upload",
};

export default pharmaciesRoutes;
